import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from "@ngx-translate/core";
import {FooterComponent} from "src/app/common/footer/footer.component";

@NgModule({
	declarations: [
		FooterComponent
	],
	exports: [
		FooterComponent
	],
	imports: [
		CommonModule,
		TranslateModule
	]
})
export class FooterModule {
}
